import type React from 'react';
import { Panel, PanelBody, PanelHeader } from '@itandi/itandi-bb-ui';
import { AccountSettingForm } from '~/components/specifics/vendors/settings/accounts/AccountSettingForm';
import { AccountSettingPassword } from '~/components/specifics/vendors/settings/accounts/AccountSettingPassword';
import type { VendorSession } from '~/models/VendorSession';

type Props = {
  session: VendorSession;
};

export const AccountSetting: React.FC<Props> = ({ session }) => (
  <Panel>
    <PanelHeader title="アカウント詳細" />
    <PanelBody>
      <AccountSettingForm session={session} />
      <AccountSettingPassword />
    </PanelBody>
  </Panel>
);
